const replayList = {
  path: 'replay/:orderId/:id/list',
  component: resolve => require(['@/pages/admin/aftersales/replay/list'], resolve)
}

export default replayList
